import { Ref, forwardRef, useMemo } from 'react';
import {
  ReactPhotoSphereViewer,
  type ViewerAPI,
} from 'react-photo-sphere-viewer';
import useResizeResponsive from '@/hooks/useResizeResponsive';
import { isDesktop } from '@/modules/utils/breakpoints';
import { ViewerConfig } from '@photo-sphere-viewer/core';

interface PanoramaViewerBaseProps
  extends Omit<Partial<ViewerAPI>, 'height' | 'width'>,
    Pick<
      ViewerConfig,
      'defaultZoomLvl' | 'defaultYaw' | 'defaultPitch' | 'sphereCorrection'
    > {
  width: string;
  height: string;
  src: string;
}

interface PanoramaViewerResponsiveProps {
  b960?: { width?: string; height?: string };
}

export type PanoramaViewerProps = PanoramaViewerBaseProps &
  PanoramaViewerResponsiveProps;

const PanoramaViewer = forwardRef(
  (
    { src, width, height, b960, ...restProps }: PanoramaViewerProps,
    ref: Ref<ViewerAPI>
  ) => {
    const isDesktopWidth = useResizeResponsive(isDesktop);

    const viewerProps = useMemo(() => {
      return isDesktopWidth && b960
        ? {
            width: b960.width || '100%',
            height: b960.width || '100%',
          }
        : {
            width,
            height,
          };
    }, [isDesktopWidth]);

    return (
      <ReactPhotoSphereViewer
        ref={ref}
        src={src}
        {...restProps}
        {...viewerProps}
      />
    );
  }
);

export default PanoramaViewer;
